import type React from 'react';
import { useEffect, useRef } from 'react';

export const useScrollTo = (deps: React.DependencyList = []) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    // biome-ignore lint/correctness/useExhaustiveDependencies: generic dependency passthrough
  }, deps);

  return { ref };
};
